import PropTypes from 'prop-types';
import React from 'react';
import _get from 'lodash/get';
import clsx from 'clsx';
import { useDevice } from '@atc/react-device';
import { getImageSizeBasedOnViewport } from '@atc/images';
import { useFeatures } from '@atc/features';
import { PositionedOverlay } from 'reaxl';
import { InventoryImage } from 'reaxl-molecules';
import InventoryListingImagePreviews from './InventoryListingImagePreviews.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function InventoryListingImage(_ref) {
  let {
    className,
    data = {},
    lazyLoad = true,
    listingCTA = {},
    loading,
    orientation,
    uiContext = 'listing',
    withPreviewImages = false,
    // only true for 'simplified' uiContext (highlight)
    ...rest
  } = _ref;
  const device = useDevice();
  const {
    inventory_carousel: [enableInventoryCarousel]
  } = useFeatures(['inventory_carousel']);
  const imageSources = _get(data, 'images.sources', []);
  const imageIndex = _get(data, ['images', 'primary'], 0);
  const image = imageSources[imageIndex] || {};
  const imgSizes = getImageSizeBasedOnViewport({
    device,
    lazyLoad
  });
  return /*#__PURE__*/_jsxs("div", {
    ...(withPreviewImages ? {
      className: 'padding-horizontal-3'
    } : {}),
    children: [/*#__PURE__*/_jsx(PositionedOverlay, {
      "data-cmp": "inventoryListImage",
      shrinkwrap: false,
      className: clsx('inventory-listing-media text-center', className),
      ...rest,
      children: /*#__PURE__*/_jsx(PositionedOverlay.Base, {
        className: clsx({
          'image-container': image.src && uiContext === 'listing',
          'bg-gray-darker': image.src,
          'inner-shadow-image-wrapper': enableInventoryCarousel
        }),
        ...imgSizes,
        children: /*#__PURE__*/_jsx(InventoryImage, {
          uiContext: uiContext,
          className: "img-responsive-scale",
          lazyLoad: lazyLoad,
          loading: loading,
          ...image,
          sizes: imgSizes
        })
      })
    }), withPreviewImages && /*#__PURE__*/_jsx(InventoryListingImagePreviews, {
      images: imageSources
    })]
  }, "inventory-listing-images");
}
export default InventoryListingImage;